import { Directive, ElementRef, HostListener, Injectable } from '@angular/core';
import { ValueConverterService } from '../services/util/value-converter.service';

@Directive({
    selector: '[appMaskValue]'
})
export class MaskValueDirective {

    constructor(private el: ElementRef,
        public readonly valueConverterService: ValueConverterService,
    ) { }

    @HostListener('input', ['$event'])
    public inputChange(event: any): void {
        this.onInputChange(event.target.value);
    }

    public onInputChange(originalValue) {
        let newVal = this.valueConverterService.formatMonetaryInput(originalValue, false);
        if (newVal){
            this.el.nativeElement.value = newVal;
        }
    }
}
